import React, { useEffect } from 'react';
import { useStoreAddress } from '../hooks/useStoreAddress';
import { AddressField, StateSelect, MunicipalitySelect, NeighborhoodSelect } from './AddressFields';
import PostalCodeSection from './PostalCodeSection';

const StoreAddress = ({
  register,
  errors,
  dataRowEdit,
  responseZipCode,
  handleZipcodeSearch,
  setValue,
  statesData,
  handleStateSelect,
  municipalities,
  handleMunicipalitySelect,
  ResponseNeighborhood,
  handleNeighborhoodSelect,
  fetchNeighborhoodLocation,
  responseNeighborhoodLocation,
  cleanNeighborhood,
  watch,
}) => {
  const {
    state,
    municipality,
    setMunicipality,
    setNeighborhood,
    setState,
    neighborhood,
    handleStateChangeAndClear,
    handleMunicipalityChange,
    handleNeighborhoodChange: handleNeighborhoodChangeLocal,
    isPostalCodeValid,
    postalCodeValue,
  } = useStoreAddress({ setValue, responseZipCode, dataRowEdit, watch });

  useEffect(() => {
    if (dataRowEdit) {
      setValue('postalCode', dataRowEdit.zipcode);
      setValue('state', dataRowEdit.state);
      setValue('municipality', dataRowEdit.municipality);
      setValue('neighborhood', dataRowEdit.neighborhood);
      setValue('street', dataRowEdit.address);
      setValue('reference', dataRowEdit.address_reference);
    }
  }, [dataRowEdit, setValue]);

  useEffect(() => {
    if (responseZipCode && responseZipCode.status) {
      setState('');
      setValue('state', '');
      setValue('municipality', '');
      setValue('neighborhood', '');
      setMunicipality('');
      setNeighborhood('');
      return;
    }
    if (responseZipCode) {
      handleStateSelect(responseZipCode.state_id);
      setValue('state', responseZipCode.state);
      setValue('municipality', responseZipCode.municipality);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseZipCode, setValue]);

  useEffect(() => {
    if (neighborhood.length > 0) {
      const selectedNeighborhood = ResponseNeighborhood.find((n) => n.name === neighborhood);
      if (
        selectedNeighborhood &&
        selectedNeighborhood.latitude === null &&
        selectedNeighborhood.longitude === null
      ) {
        fetchNeighborhoodLocation(selectedNeighborhood.id);
      }
    }
  }, [neighborhood, ResponseNeighborhood, fetchNeighborhoodLocation]);

  useEffect(() => {
    if (responseNeighborhoodLocation) {
      const { lat, lng } = responseNeighborhoodLocation;
      setValue('latitude', lat);
      setValue('longitude', lng);
    }
  }, [responseNeighborhoodLocation, setValue]);

  const handleSearchAndClear = () => {
    handleZipcodeSearch();
    cleanNeighborhood();
  };

  return (
    <>
      <PostalCodeSection
        register={register}
        errors={errors}
        dataRowEdit={dataRowEdit}
        postalCodeValue={postalCodeValue}
        isPostalCodeValid={isPostalCodeValid}
        responseZipCode={responseZipCode}
        handleSearchAndClear={handleSearchAndClear}
      />
      <StateSelect
        state={state}
        statesData={statesData}
        handleStateChangeAndClear={handleStateChangeAndClear}
        handleStateSelect={handleStateSelect}
        register={register('state', {
          required: 'Estado es obligatorio',
        })}
        error={errors.state}
        dataRowEdit={dataRowEdit}
      />
      <MunicipalitySelect
        dataRowEdit={dataRowEdit}
        municipality={municipality}
        state={state}
        municipalities={municipalities}
        handleMunicipalityChange={handleMunicipalityChange}
        handleMunicipalitySelect={handleMunicipalitySelect}
        responseZipCode={responseZipCode}
        register={register('municipality', {
          required: 'Municipio es obligatorio',
        })}
        error={errors.municipality}
      />
      <NeighborhoodSelect
        neighborhood={neighborhood}
        municipality={municipality}
        ResponseNeighborhood={ResponseNeighborhood}
        handleNeighborhoodChangeLocal={handleNeighborhoodChangeLocal}
        handleNeighborhoodSelect={handleNeighborhoodSelect}
        responseZipCode={responseZipCode}
        register={register('neighborhood', {
          required: 'Colonia es obligatoria',
        })}
        error={errors.neighborhood}
        dataRowEdit={dataRowEdit}
        setValue={setValue}
      />
      <AddressField
        label='Calle y número'
        defaultValue={dataRowEdit?.address}
        register={register('street', {
          required: 'Calle y número son obligatorios',
        })}
        error={errors.street}
        helperText={errors.street?.message}
      />
      <AddressField
        label='Referencia'
        defaultValue={dataRowEdit?.address_reference}
        register={register('reference', {
          required: 'Referencia es obligatoria',
        })}
        error={errors.reference}
        helperText={errors.reference?.message}
      />
    </>
  );
};
export default StoreAddress;
